<template>
  <div class="dynamics-info">
    <mainPage :menus="menus">
      <el-card>
        <div class="detail_wrap">
          <div class="title">
            从一季度陆海新通道国际工商会联盟合作圆桌会
          </div>
          <div class="detail">
            <i class="iconfont icon-shijian"></i> <span>{{detailInfo.date}}</span>
            <i class="iconfont icon-chakan"></i> <span>{{detailInfo.view}}</span>
            <i class="iconfont icon-laiyuan"></i> <span>来源：{{detailInfo.source}}</span>
          </div>
          <div class="content">
            <p>作为陆海新通道国际工商会“重庆行”的重要内容，陆海新通道国际工商会合作圆桌会10月24日举行。来自国内以及新加坡、老挝、缅甸、伊朗、乌兹别克斯坦等国家的工商业代表，共同分享了通过陆海新通道，加强地区间联系、促进经济贸易发展的思路和建议。代表们表示，要不断增强国际合作，为沿线国家的企业提供更多 多元化平台，更好地释放陆海新通道的潜力。</p>
            <img src="../assets/img/3.png" alt="">
            <p>作为陆海新通道国际工商会“重庆行”的重要内容，陆海新通道国际工商会合作圆桌会10月24日举行。来自国内以及新加坡、老挝、缅甸、伊朗、乌兹别克斯坦等国家的工商业代表，共同分享了通过陆海新通道，加强地区间联系、促进经济贸易发展的思路和建议。代表们表示，要不断增强国际合作，为沿线国家的企业提供更多 多元化平台，更好地释放陆海新通道的潜力。</p>
            <p>(第1眼-重庆广电记者 宋念念 富治平)</p>
          </div>
        </div>
      </el-card>
    </mainPage>
  </div>
</template>

<script>
import mainPage from './layout/main-page'

export default {
  name: 'dynamics-info',
  components: { 
    mainPage
  },
  data () {
    return {
      detailInfo: {
        date: '2025-04-27',
        view: 3298,
        source: '视界网/重庆网络广播电视台'
      },
      menus: [
        {value: '1', label: '联盟新闻'},
        {value: '2', label: '成员风采'},
      ],
    }
  },
  filters: {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.dynamics-info{
  .detail_wrap{
    padding: 20px;
  }
  .title{
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    margin: 30px 0;
  }
  .detail{
    color: #999999;
    border-bottom: 1px solid #EBEEF5;
    padding-bottom: 10px;
    margin-bottom: 20px;
    span{
      margin-right: 20px;
    }
  }
  .content{
    line-height: 28px;
    color: #505050;
    img{
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dynamics-info.vue